import { render, staticRenderFns } from "./jd-input-price.vue?vue&type=template&id=0e472b9c&scoped=true&"
import script from "./jd-input-price.vue?vue&type=script&lang=js&"
export * from "./jd-input-price.vue?vue&type=script&lang=js&"
import style0 from "./jd-input-price.vue?vue&type=style&index=0&id=0e472b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e472b9c",
  null
  
)

export default component.exports